// extracted by mini-css-extract-plugin
module.exports = {"headerBar":"nf-z","pointsSection":"of-z","goToDashboard":"pf-z"};